import React, { useState } from "react";

// 👉 Replace with your real WhatsApp number (with country code, no + or spaces)
// Example: +91 98765 43210 → "919876543210"
const WHATSAPP_NUMBER = "918275607686";

export default function RoomCard({ room }) {
  const [showPopup, setShowPopup] = useState(false);

  // Local images served from public/images folder, e.g. "/images/room1.jpg"
  const imageSrc = room.image;

  const openWhatsApp = () => {
    const message = `Hi, I want to book Room #${room.roomNumber} (${room.roomType}) - ₹${room.price}/night.`;
    const url = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(message)}`;
    window.open(url, "_blank");
    setShowPopup(false);
  };

  return (
    <div className="col-md-4 col-sm-6 mb-4">
      <div className="card shadow-lg border-0 rounded-4 h-100">
        {/* Room Image */}
        <img
          src={imageSrc}
          alt={room.roomType}
          style={{ width: "100%", height: "180px", objectFit: "cover", borderRadius: "10px" }}
        />

        {/* Card Body */}
        <div className="card-body">
          <h5 className="card-title fw-bold text-primary">{room.roomType}</h5>

          <div className="d-flex justify-content-between mt-2">
            <span className="badge bg-dark">Room #{room.roomNumber}</span>
            <span className="badge bg-secondary">{room.capacity} Guests</span>
          </div>

          <p className="mt-3 mb-0 text-success fw-bold fs-5">
            ₹{room.price} / person
          </p>
        </div>

        {/* Book Button */}
        <div className="card-footer bg-white border-0 pb-3 px-3 d-flex flex-column gap-2">
          <button
            onClick={() => setShowPopup(true)}
            className="btn w-100 rounded-pill"
            style={{ background: "#25D366", color: "#fff", border: "none" }}
          >
            Book via WhatsApp
          </button>
        </div>
      </div>

      {/* Confirmation Popup */}
      {showPopup && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            background: "rgba(0,0,0,0.5)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 1050,
          }}
          onClick={() => setShowPopup(false)}
        >
          <div
            className="bg-white rounded-4 p-4 text-center"
            style={{ width: "300px" }}
            onClick={(e) => e.stopPropagation()}
          >
            <h5 className="fw-bold mb-3">Confirm Booking</h5>
            <p>
              Book <b>{room.roomType}</b> (Room #{room.roomNumber}) via WhatsApp?
            </p>
            <div className="d-flex justify-content-center gap-2 mt-3">
              <button
                onClick={openWhatsApp}
                className="btn rounded-pill px-3"
                style={{ background: "#25D366", color: "#fff", border: "none" }}
              >
                Yes, Continue
              </button>
              <button
                onClick={() => setShowPopup(false)}
                className="btn btn-light rounded-pill px-3"
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}